import { AllContents, AllContentsState } from '../types/allContentTypes'
import { FetchAllContentResponse } from '../features/allcontent/allContentState'
const API_URL = process.env.REACT_APP_API_URL

export const fetchAllContent = async (): Promise<FetchAllContentResponse> => {
  try {
    const response = await fetch(`${API_URL}/aggregate-data`)

    const data = await response.json()
    if (response.ok) {
      return { success: true, allContents: data }
    } else {
      return {
        success: false,
        message: data.message || 'Failed to fetch books',
      }
    }
  } catch (error) {
    console.error('Error trying to fetch books', error)
    return {
      success: false,
      message: 'An error occurred during fetching books',
    }
  }
}
